import styled from "styled-components";
import { DropdownContent } from "@sonder/ui/source/styled/components/DropdownContent";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import { ButtonList } from "@sonder/ui/source/styled/fragments/ButtonList";
import { Label } from "@sonder/ui/source/styled/fragments/Label";
import { TextArea } from "@sonder/ui/source/styled/fragments/TextArea";
import { borders, colors } from "@sonder/ui/source/styled/theme";

export const FilterDropdownContent = styled(DropdownContent)`
  flex-direction: column;
`;

export const FilterTextArea = styled(TextArea)`
  flex: 1 1 auto;
  margin: 0.5rem;
  padding: 0.5rem;
`;

export const FilterButtonList = styled(ButtonList)`
  max-width: 22rem;
  padding-bottom: 0.5rem;
  width: 100%;
`;

export const FilterEmpty = styled.p`
  color: ${colors.grayA};
  text-align: center;
`;

export const FilterFooter = styled.div`
  align-items: center;
  border-top: ${borders.standard};
  display: flex;
  flex-direction: row;
  padding: 0.5rem;
  justify-content: space-between;
`;

export const FilterHeader = styled.div`
  align-items: center;
  border-bottom: ${borders.standard};
  display: flex;
  flex-direction: row;
`;

export const FilterGroupItem = styled(Button)`
  text-align: left;

  ${Label} {
    align-items: center;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &:not(:disabled) {
    ${Label} {
      cursor: pointer;
    }
  }
`;
